import { autoinject, bindable } from 'aurelia-framework';
import { GlobalContextService } from '../../components/global-select/global-context-service';
import { CustomerService } from '../../features/customers/customer-service';

@autoinject
export class GlobalCustomer {
    @bindable customerId: string;

    constructor(private context: GlobalContextService, private customerService: CustomerService) {
    }

    attached() {
        this.context.setId("customer", this.customerId);
        if (this.customerId != null) {
			this.customerService.getCustomer(this.customerId).then(customer => {

				// Commented out to stop the customer scope from being reset on full page reloads.
				// Setting the scope null here will cause weird behaviours in pages that are dependent on the scope info,
				// as there the global-select component will not set the selected scope to context in time for the page to use it.
				// this.context.setItem('scope', null); 

				this.context.setItem('customer', customer);
            });
        }
    }
}
